module.exports = __webpack_public_path__ + "img/travolta.7e403af7.gif";